



































































import { Component, Vue, Prop } from "../vue-ext";
import "../components/LoginTopNav";
import { User } from "../models";

@Component
export default class InputRegisterFormView extends Vue {
    private user: User | null = null;

    private created() {
        this.user = this.root.getCurrentUser() as User;
    }

    private requiredFieldsFilled() {
        if (this.user == null)
            return false;

        if (this.user.isCompany) {
             return this.user.companyName && this.user.businessId &&
                this.user.phone && this.user.email && this.user.streetAddress &&
                this.user.zipCode && this.user.city;
        }

        return this.user.firstName && this.user.lastName && this.user.ssn &&
                this.user.phone && this.user.email && this.user.streetAddress &&
                this.user.zipCode && this.user.city;
    }

    private async register() {
        if (this.user == null)
            return;

        if (!this.requiredFieldsFilled())
            return;
        
        const res = await this.root.service.user.Register(this.user);

        if (!res.isError) {
            this.$router.push("/input-pin");
        }
    }
}
